/** Deduplicate option labels (case-insensitive) and sort for filter dropdowns. */
export function normalizeFilterSelectOptions(options: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of options) {
    const label = raw.trim();
    if (!label) continue;
    const key = label.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(label);
  }
  return out.sort((a, b) => a.localeCompare(b));
}

/** Filter dropdown options by a case-insensitive substring match. */
export function filterSelectOptions(options: string[], query: string): string[] {
  const normalized = normalizeFilterSelectOptions(options);
  const q = query.trim().toLowerCase();
  if (!q) return normalized;
  return normalized.filter((label) => label.toLowerCase().includes(q));
}
